import React from "react";
import { Link, Navigate } from "react-router-dom";
import Logo from "../../images/logo.png";
import Cookies from "js-cookie";
import { Button, Input } from "@heroui/react";

const ForgotPassword = () => {
  const token = Cookies.get("baf_base_user_token");

  // If token exists, redirect before rendering
  if (token) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <div className="flex flex-col auth-section-bg min-h-dvh h-full justify-center">
        {/* <div className="p-4 lg:px-16">
          <Link to="/" className="block">
            <span className="sr-only">BAF</span>
            <img
              alt="Logo"
              src={Logo}
              className="h-auto w-[6rem] sm:w-[8rem]"
            />
          </Link>
        </div> */}
        <div className="w-full p-4 pb-8 flex justify-center items-center mt-16">
          <div className="max-w-[31rem] mx-auto w-full bg-white rounded-3xl overflow-hidden">
            <div className="py-2 px-4 bg-black">
              <Link to="/" className="block w-fit mx-auto">
                <span className="sr-only">BAF</span>
                <img
                  alt="Logo"
                  src={Logo}
                  className="h-auto w-[6rem] sm:w-[8rem]"
                />
              </Link>
            </div>
            <div className="max-w-[25rem] mx-auto p-4">
              <h2 className="text-3xl font-bold mb-8 text-center">
                Forgot your password?
              </h2>
              <form className="flex flex-col gap-4">
                <p className="text-sm text-gray-600 m-0">
                  Enter your email and we'll send you a link to reset your
                  password.
                </p>
                <div className="flex flex-col gap-1">
                  <Input
                    label=""
                    placeholder="Email Address"
                    labelPlacement="outside"
                    type="email"
                    name="email"
                    variant="bordered"
                    classNames={{
                      base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                      label: "hidden",
                      inputWrapper:
                        "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                    }}
                    radius="md"
                  />
                  {/* {errors.email && (
                    <small className="text-red-500 text-xs block">
                      {errors.email}
                    </small>
                  )} */}
                </div>
                <Button
                  type="submit"
                  className="bg-yellowbuy border border-black rounded-lg"
                  radius="none"
                >
                  Send Reset Link
                </Button>
                <p className="text-xs text-gray-500 text-center m-0">
                  Remember your password?{" "}
                  <Link to="/login" className="text-[#9747FF] underline">
                    Go back to login
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
